export const formatUsdPer = (usd: any) => {
	if (!usd) {
		return { usd: 0 }
	}

	const magnitude = Math.max(-Math.floor(Math.log(usd) / Math.log(10) + 1), 0)
	return { usd: parseFloat(usd.toFixed(Math.min(magnitude + 2, 24))) }
}

export const formatUsdDisplay = (usd: number): string => {
	if (!usd || !isFinite(usd)) return '0.00'
	if (usd >= 1) {
		return usd.toLocaleString('en-US', {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		})
	}
	if (usd >= 0.01) {
		return usd.toFixed(2)
	}
	const leadingZeros = -Math.floor(Math.log10(usd) + 1)
	const decimals = Math.min(leadingZeros + 2, 20)
	return usd.toFixed(decimals).replace(/0+$/, '').replace(/\.$/, '')
}

// Per-unit USD rendered as price-per-billion (e.g. 2.2135e-7 → "$221.35/B").
// For high-supply tokens like tap-DMT-NAT where the per-unit price is too
// small to read as a plain dollar value. Never emits exponent notation:
// toPrecision() did ("$1.6792e+6/B"), so large values abbreviate to k/m/b.
export const formatUsdPerBillion = (usdPerUnit: number): string => {
	if (!usdPerUnit || !isFinite(usdPerUnit) || usdPerUnit < 0) return '$0/B'
	return `$${formatCompactPlain(usdPerUnit * 1e9)}/B`
}

/** Plain-decimal number for tight UI: 1.23b / 45.6m / 7.89k, else ~4
 * significant digits without exponent notation (0.12253, 85.63). */
export const formatCompactPlain = (v: number): string => {
	if (!isFinite(v) || v <= 0) return '0'
	if (v >= 1e9) return `${trimZeros((v / 1e9).toFixed(2))}b`
	if (v >= 1e6) return `${trimZeros((v / 1e6).toFixed(2))}m`
	if (v >= 1e3) return `${trimZeros((v / 1e3).toFixed(2))}k`
	if (v >= 1) return trimZeros(v.toFixed(2))
	const decimals = Math.min(-Math.floor(Math.log10(v)) + 3, 20)
	return trimZeros(v.toFixed(decimals))
}

const trimZeros = (s: string): string =>
	s.includes('.') ? s.replace(/0+$/, '').replace(/\.$/, '') : s
